import getListNumber from './getListNumber';

// 年齢制限の定数
const MIN_AGE = 18;
const MAX_AGE = 70;

/**
 * 年齢制限に基づいて年の範囲を生成する
 * @returns {number[]} 年の配列（降順）
 */
const getYearRange = (): number[] => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - MAX_AGE - 1;
  const endYear = currentYear - MIN_AGE - 1;
  return getListNumber(startYear, endYear);
};

export default getYearRange;
